import React from 'react';
import { Icon } from '../style';

export function TMNeutral(properties) {
  return (
    <Icon
      {...properties}
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 60.95 60.95"
    >
      <defs>
        <radialGradient
          id="b068dbfb-7fa1-4114-8392-a26aab7f0c37"
          cx="-100.2"
          cy="314.5"
          r="1"
          gradientTransform="matrix(36.77 0 0 -36.77 3717.86 11590.41)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0" stopColor="#ffe030" />
          <stop offset="1" stopColor="#ffb92e" />
        </radialGradient>
        <radialGradient
          id="b9c7a5b0-c270-4b7d-abf1-ce8a484cf08c"
          cx="-99.44"
          cy="312.74"
          r="1"
          gradientTransform="matrix(28.93 0 0 -28.93 2910.29 9073.61)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0" stopColor="#ffea5f" />
          <stop offset="1" stopColor="#ffbc47" stopOpacity="0" />
        </radialGradient>
        <radialGradient
          id="ac15a355-2627-410c-9180-e70d2e5b4ab4"
          cx="-43.03"
          cy="332.66"
          r="1"
          gradientTransform="matrix(1.2 4.14 2.68 -.77 -809.52 472.7)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0" stopColor="#7a4400" />
          <stop offset="1" stopColor="#643800" />
        </radialGradient>
        <radialGradient
          id="a63deb15-a9b7-4287-a500-89388fa7244e"
          cx="-43.03"
          cy="332.66"
          r="1"
          gradientTransform="matrix(1.2 4.14 2.68 -.77 -789.62 472.7)"
          xlinkHref="#ac15a355-2627-410c-9180-e70d2e5b4ab4"
        />
        <radialGradient
          id="e4aa49a9-77b9-4744-861f-7124f322bccf"
          cx="-92.84"
          cy="189.96"
          r="1"
          gradientTransform="matrix(10.14 0 0 -1.82 981.27 398.34)"
          xlinkHref="#ac15a355-2627-410c-9180-e70d2e5b4ab4"
        />
        <linearGradient
          id="b43205fc-1bf7-48fe-b56f-610101074b2c"
          x1="27.81"
          x2="28.3"
          y1="53.72"
          y2="57.54"
          gradientTransform="matrix(1 0 0 -1 0 82)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0" stopColor="#3c2200" />
          <stop offset="1" stopColor="#7a4400" />
        </linearGradient>
        <linearGradient
          id="f4784509-2452-46e1-9426-bb9c3a8bd36d"
          x1="30.06"
          x2="30.06"
          y1="49.6"
          y2="45.46"
          gradientTransform="matrix(1 0 0 -1 0 82)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0" stopColor="#3c2200" />
          <stop offset="1" stopColor="#512d00" />
        </linearGradient>
        <linearGradient
          id="bbf52ea5-4ec5-4081-be79-ef2cd44d345a"
          x1="49.94"
          x2="49.94"
          y1="49.49"
          y2="45.35"
          xlinkHref="#f4784509-2452-46e1-9426-bb9c3a8bd36d"
        />
        <linearGradient
          id="a2e933d8-fea8-45b6-94fc-b09ad4bbef2d"
          x1="52.19"
          x2="51.7"
          y1="53.72"
          y2="57.54"
          xlinkHref="#b43205fc-1bf7-48fe-b56f-610101074b2c"
        />
        <linearGradient
          id="ad9959ad-b88a-41f1-acea-3a254c86c886"
          x1="25.73"
          x2="54.27"
          y1="30.79"
          y2="30.79"
          xlinkHref="#f4784509-2452-46e1-9426-bb9c3a8bd36d"
        />
      </defs>
      <path
        fill="url(#b068dbfb-7fa1-4114-8392-a26aab7f0c37)"
        d="M40 70.48A30.48 30.48 0 1 0 9.52 40 30.48 30.48 0 0 0 40 70.48Z"
        transform="translate(-9.52 -9.52)"
      />
      <path
        fill="url(#b9c7a5b0-c270-4b7d-abf1-ce8a484cf08c)"
        d="M40 70.48A30.48 30.48 0 1 0 9.52 40 30.48 30.48 0 0 0 40 70.48Z"
        opacity=".5"
        style={{ isolation: 'isolate' }}
        transform="translate(-9.52 -9.52)"
      />
      <path
        fill="url(#b43205fc-1bf7-48fe-b56f-610101074b2c)"
        d="M34.5 26.67c.19-1.45-1-2.54-3.26-2.82-1.93-.25-6.29.47-9.75 4.57-.65.76.11 1.31.72.86C24.23 27.7 29.3 26 33 27c1.42.31 1.5-.33 1.5-.33Z"
        transform="translate(-9.52 -9.52)"
      />
      <path
        fill="url(#ac15a355-2627-410c-9180-e70d2e5b4ab4)"
        d="M30.06 41.3c1.62 0 2.93-2 2.93-4.44s-1.31-4.44-2.93-4.44-2.94 2-2.94 4.44 1.32 4.44 2.94 4.44Z"
        transform="translate(-9.52 -9.52)"
      />
      <path
        fill="url(#f4784509-2452-46e1-9426-bb9c3a8bd36d)"
        d="M30.06 33.92c1.25 0 2.36 1.11 2.93 2.73 0-2.4-1.33-4.33-2.93-4.33s-2.9 1.93-2.94 4.33c.57-1.65 1.66-2.73 2.94-2.73Z"
        transform="translate(-9.52 -9.52)"
      />
      <path
        fill="url(#a63deb15-a9b7-4287-a500-89388fa7244e)"
        d="M49.94 41.3c1.62 0 2.94-2 2.94-4.44s-1.32-4.44-2.94-4.44S47 34.41 47 36.86s1.32 4.44 2.94 4.44Z"
        transform="translate(-9.52 -9.52)"
      />
      <path
        fill="url(#bbf52ea5-4ec5-4081-be79-ef2cd44d345a)"
        d="M49.94 34c-1.25 0-2.36 1.1-2.93 2.72 0-2.4 1.33-4.32 2.93-4.32s2.9 1.92 2.94 4.32C52.3 35.14 51.22 34 49.94 34Z"
        transform="translate(-9.52 -9.52)"
      />
      <path
        fill="url(#a2e933d8-fea8-45b6-94fc-b09ad4bbef2d)"
        d="M45.5 26.67c-.19-1.45 1-2.54 3.26-2.82 1.93-.25 6.29.47 9.75 4.57.65.76-.11 1.31-.72.86C55.77 27.7 50.7 26 47.05 27c-1.47.31-1.55-.33-1.55-.33Z"
        transform="translate(-9.52 -9.52)"
      />
      <path
        fill="url(#e4aa49a9-77b9-4744-861f-7124f322bccf)"
        d="M52.84 53.3H27.16a1.43 1.43 0 0 1 0-2.86h25.68a1.43 1.43 0 1 1 0 2.86Z"
        transform="translate(-9.52 -9.52)"
      />
      <path
        fill="url(#ad9959ad-b88a-41f1-acea-3a254c86c886)"
        d="M27 51.2h26a1.44 1.44 0 0 1 1.28.78v-.11a1.44 1.44 0 0 0-1.43-1.43H27.16a1.44 1.44 0 0 0-1.43 1.43V52a1.44 1.44 0 0 1 1.27-.8Z"
        transform="translate(-9.52 -9.52)"
      />
    </Icon>
  );
}
